import {useEffect} from 'react';
import {useSelector} from 'react-redux';

import useFwuBackgroundCheckEnabled from '@/hooks/fwu/useFwuBackgroundCheckEnabled';
import mwFwuService from '@/services/mw/mwFwuService';
import {selectIsDeviceConnectedToIot, selectIsHolderConnectedToIot} from '@/state/selectors/device';

const useFwuChecker = () => {
    const isDeviceConnectedToIot = useSelector(selectIsDeviceConnectedToIot);
    const isHolderConnectedToIot = useSelector(selectIsHolderConnectedToIot);
    const isFwuCheckEnabled = useFwuBackgroundCheckEnabled();

    const checkFwuAvailability = (isHolder) => {
        if (!isFwuCheckEnabled) return;

        mwFwuService.checkFwuAvailability(isHolder);
    };

    useEffect(() => {
        if (!isDeviceConnectedToIot) return;

        checkFwuAvailability();
    }, [isDeviceConnectedToIot, isFwuCheckEnabled]);

    useEffect(() => {
        if (!isHolderConnectedToIot) return;

        checkFwuAvailability(true);
    }, [isHolderConnectedToIot, isFwuCheckEnabled]);
};

export default useFwuChecker;
